module.exports = __webpack_public_path__ + "static/media/Metamask.200daea3.png";